export const data = [
  {
    body: '<div class="trix-content">\n  <div class="pb-5">While EasyLlama has occasional technical issues, they are rare. Technical issues with EasyLlama training are usually caused by the individual user\'s browser, network, or device. Here are some basic troubleshooting steps if you experience these issues: \n</div>' +
      '<ol>'+
      '<li>1. Complete all the steps, as instructed on the screen - each activity must be completed to move on to the next slide. Make sure you have listened to all audio elements.</li>' +
      '<li>2. Refresh the browser and try clicking the play button again.</li>' +
      '<li>3. Be sure to use an up-to-date, supported browser - Chrome, Firefox, Edge, or Safari. Safari not currently supported for HIPAA courses.</li>' +
      '<li>4. Be sure there is a solid connection and sufficient bandwidth.</li>' +
      '<li>5. Make sure Audio and JavaScript are enabled.</li>' +
      '</ol>' +
      '<div class="pt-5">If the issues persist, we recommend you try opening the training in a different browser, or on another device (tablet, smartphone, computer).</div>' +
      '\n</div>\n',

    id: '49',
    title:
      'The screen is freezing/I am unable to start the course/white screen',
    __typename: 'Help'
  },
  {
    body: '<div class="trix-content">' +
      '<p class="pb-5">Reasons a "next" button may not appear or work:</p>' +
      '<p class="pb-5">Occasionally some elements will get hung up in your browser and not appear - this happens often with the "Next" button.</p>' +
      '<p class="pb-5">Please try refreshing your browser, completing everything on the slide again if needed, and the button should appear.</p>' +
      '<p>All videos or sound bytes have not been played.</p>' +
      '<ul class="pb-5">' +
        '<li>Make sure to use the Previous (&lt;) and Next (&gt;) buttons to view all the videos on a multi-video slide, or click all the icons, as instructed. </li>' +
        '<li>Always wait for one to complete before going on to the next one. Starting the next Audio or Video clip early may mean you will have to re-watch the whole clip before you can move on. </li>' +
      '</ul>' +
      '<p class="pb-5">Wrong answers have been chosen on a quiz, activity, or Knowledge Check.\n</p>' +
      '<ul class="pb-5">' +
        '<li>Some activities will not allow you to advance until you have chosen the correct answers. </li>' +
        '<li>Some will require you to click or drag answers back before choosing correct answers. </li>' +
      '</ul>' +
      '<p class="pb-5">If none of these seem to be the issue or if you are continually experiencing technical issues with your course, please be sure you are using the most up-to-date version of a supported browser. Chrome is the most highly recommended browser, followed by Edge and Safari. Safari users most frequently experience issues with the course. </p>' +
      '<p class="pb-5">Internet Explorer, Duck-Duck-Go and other browsers are not supported.</p></div>',
    id: '55',
    title:
      "There's no Next Button, or some elements seem to be missing - I can't advance my slide.",
    __typename: 'Help'
  },
  {
    body: '<div class="trix-content">' +
      '<p>Chrome, Firefox, Edge and Safari* are supported. In unsupported browsers, users may encounter performance issues and functionality may be limited. If you are experiencing issues is a supported browser, please be sure to use the most up-to-date version, or try another supported browser. </p>' +
      '</div>\n',
    id: '48',
    title: 'Which Browsers are Supported by EasyLlama?',
    __typename: 'Help'
  }
];
